export enum TierKeys {
    medals = 'medals',
    journey = 'journey',
    sports = 'sports',
    martialArts = 'martial arts',
    shopping = 'shopping',
}

export enum LevelIcons {
    shield = 'shield',
    bolt = 'bolt',
    medal = 'medal',
    trophy = 'trophy',
}

export enum TierColors {
    bronze = '#d79957',
    silver = '#9e9e9e',
    gold = '#fecb45',
    platinum = '#242425',
    diamond = '#19a1d7'
}

export enum TierIcons {
    bronze = 'https://static.gamiphy.co/assets/imgs/app/new-product/tiers/Bronze.svg',
    silver = 'https://static.gamiphy.co/assets/imgs/app/new-product/tiers/Silver.svg',
    gold = 'https://static.gamiphy.co/assets/imgs/app/new-product/tiers/Gold.svg',
    platinum = 'https://static.gamiphy.co/assets/imgs/app/new-product/tiers/Platinuim.svg',
    diamond = 'https://static.gamiphy.co/assets/imgs/app/new-product/tiers/Diamond.svg'
}

export enum TierConfigPeriod {
    noExpire = 'noExpire',
    halfYear = 'halfYear',
    yearly = 'yearly',
    biYearly = 'biYearly',
}

export enum TierConfigType {
    gainedPoints = 'gainedPoints',
    valueOfPurchases = 'valueOfPurchases',
    numberOfPurchases = 'numberOfPurchases',
    exp= 'exp',
}

export enum TierConfigUseCashback {
    false = 'false',
    true = 'true'
}
